import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import { get, put, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useParams, useNavigate } from "react-router-dom"
import {
  UPDATE_PAYMENT_STATUS,
  LANGUAGES_SEARCH,
  SHOW_PAYMENT_STATUS,
  COUNTRIES_SEARCH,
  UPLOAD_FILE,
} from "helpers/api_endpoints"
import Select from "react-select"
import { Trans } from "react-i18next"

document.title = "Edit Payment Status"

function EditPaymentStatus() {
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setid] = useState("")
  const [name, setName] = useState("")
  const [status, setStatus] = useState(0)
  const [symbol, setSymbol] = useState("")
  const [valued, setValued] = useState({ title: [] })
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const getPaymentStatus = async () => {
      setLoading(true)
      try {
        const response = await get(`${SHOW_PAYMENT_STATUS}/${params.id}`)
        const paymentStatus = response.data
        setid(params.id)
        setName(paymentStatus.name)
        setStatus(paymentStatus.status)
        setSymbol(paymentStatus.symbol)
        if (paymentStatus.named && paymentStatus.named.title) {
          setValued(paymentStatus.named)
        } else {
          setValued({ title: [{ 1: paymentStatus.name }] })
        }
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    const getLanguages = async () => {
      setLoading(true)
      try {
        const response = await post(`${LANGUAGES_SEARCH}`, { status: 1 })
        const languages = response.data
        setLanguages(languages)
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }

    const getCountries = async () => {
      setLoading(true)
      try {
        const response = await post(`${COUNTRIES_SEARCH}`)
        const countries = response.data
        setCountries(countries.map(country => ({
          value: country.id,
          label: country.name,
          ...country
        })))
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    getPaymentStatus()
    getLanguages()
    getCountries()
  }, [params.id])

  const handleSubmit = () => {
    put(UPDATE_PAYMENT_STATUS, { id, name, status, symbol, countryId: selectedCountry?.value })
      .then(response => {
        if (response.code == 200) {
          navigate("/payment-statuses", {
            state: { successMsg: "Payment Status Updated Successfully" },
          })
        }
      })
      .catch(error => {
        console.log(error)
        seterrorMsg(error.message)
      })
  }

  const handleName = (languageId, value) => {
    if (!valued.title) {
      const ob = {}
      ob[languageId] = value
      setValued({ title: [ob] })
      return
    }
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(valued))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Payment Status"
            breadcrumbItem="Edit Payment Status"
          />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg ? (
                        <Alert color="danger">{errorMsg}</Alert>
                      ) : null}
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              name="name"
                              value={
                                valued.title
                                  ? valued.title.find(el => {
                                      return el[language.id]
                                    })
                                    ? valued.title.find(el => {
                                        return el[language.id]
                                      })[language.id]
                                    : ""
                                  : JSON.stringify(valued)
                              }
                              className="form-control"
                              placeholder="Enter  Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                    </Row>
                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Country</Trans>
                        </Label>
                        <Select
                          name="countryId"
                          value={selectedCountry}
                          onChange={setSelectedCountry}
                          options={countries}
                          getOptionValue={option => option.value}
                          getOptionLabel={option => option.name}
                          placeholder="Select Country"
                          isClearable
                          required
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Symbol</Trans>
                        </Label>
                        <Input
                          name="symbol"
                          value={symbol}
                          className="form-control"
                          placeholder="Enter Symbol"
                          type="text"
                          onChange={e => setSymbol(e.target.value)}
                          required
                        ></Input>
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <select
                          className="form-control"
                          onChange={e => setStatus(e.target.value)}
                          required
                        >
                          <option value=""></option>
                          <option value={1} selected={status == 1}>
                            <Trans>Active</Trans>
                          </option>
                          <option value={0} selected={status == 0}>
                            <Trans>Non Active</Trans>
                          </option>
                        </select>
                      </div>
                    </Row>
                    <div className="text-center  mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditPaymentStatus
